import {
  Box,
  Flex,
  Heading,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { Header } from "../../components/Header";
import { Loading } from "../../components/Loading";
import { useAgenciasAfiliadas } from "../../hooks/agencias/useAgenciasAfiliadas";

function formatPercent(value: number) {
  return `${Number(value ?? 0).toLocaleString("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}%`;
}

export function AgenciasAfiliadas() {
  const { data: agencias = [], isLoading, isError } = useAgenciasAfiliadas();

  return (
    <Box
      display={"flex"}
      flexDir={"column"}
      justifyContent={"center"}
      width={"full"}
      alignItems={"center"}
    >
      <Flex
        maxWidth={"90%"}
        width={"100%"}
        flexDir={"column"}
        justifyContent={"center"}
      >
        <Header />
        <Box
          px={"1rem"}
          bg={"white"}
          w={"full"}
          display={"flex"}
          flexDir={"column"}
          gap={6}
          pb={8}
        >
          <Box>
            <Heading as="h1" fontSize={"2xl"} color={"purple.900"}>
              Agências afiliadas
            </Heading>
            <Text color={"gray.600"} mt={2}>
              Agências vinculadas à sua representação e suas taxas cadastradas.
            </Text>
          </Box>

          {isLoading && <Loading />}

          {isError && (
            <Text color={"red.500"}>
              Não foi possível carregar as agências afiliadas.
            </Text>
          )}

          {!isLoading && !isError && agencias.length === 0 && (
            <Text color={"gray.600"}>
              Nenhuma agência afiliada encontrada.
            </Text>
          )}

          {!isLoading && !isError && agencias.length > 0 && (
            <TableContainer>
              <Table variant={"simple"}>
                <Thead>
                  <Tr>
                    <Th>Agência</Th>
                    <Th isNumeric>Taxa agência</Th>
                    <Th isNumeric>Taxa GoPass</Th>
                    <Th isNumeric>Taxa representante</Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {agencias.map((agencia) => (
                    <Tr key={agencia.id}>
                      <Td>{agencia.nome}</Td>
                      <Td isNumeric>{formatPercent(agencia.taxa_agencia)}</Td>
                      <Td isNumeric>{formatPercent(agencia.taxa_gopass)}</Td>
                      <Td isNumeric>{formatPercent(agencia.taxa_representante)}</Td>
                    </Tr>
                  ))}
                </Tbody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </Flex>
    </Box>
  );
}
